<template>
  <div class="platform-advantage">
    <div class="title">平台优势</div>
    <div class="box">
      <div  class="item" v-for="item in platformAdvantage" :key="item.id">
        <img :src="item.src" />
        <div class="title">{{item.title}}</div>
        <div class="description">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'PlatformAdvantage',
		data() {
      return {
        platformAdvantage: [{
          id: 0,
          title: '开放中立',
          content: '开放、中立和融合的AI平台技术产品和服务，支持多种开源深度学习框架，不绑定任何特定的技术和服务框架。',
          src: require('@/assets/images/open.png')
        }, {
          id: 1,
          title: '极致性能',
          content: '各类框架运行于GPU服务器。超强算力的GPU集群的支撑以及先进的云平台技术提供高并行、高吞吐、低时延的极致性能。在科学计算表现中性能比传统架构提高50倍。',
          src: require('@/assets/images/performance.png')
        }, {
          id: 2,
          title: '弹性灵活',
          content: '平台可随时创建深度学习训练环境和训练任务，灵活配置资源满足不同场景需求。高效的机器学习运维管理 (MLOps) 全流程支持 AI 模型的构建、训练和部署。',
          src: require('@/assets/images/flexibility.png')
        }, {
          id: 3,
          title: '开箱即用',
          content: '平台预置TensorFlow, PyTorch 和 MxNet等近十种人工智能开源框架，一键快速提交训练任务。数据模型分析交互式开发工具 MLab，支持一键添加代码和数据集。',
          src: require('@/assets/images/box-use.png')
        }, {
          id: 4,
          title: '成本优化',
          content: '高效的资源优化调度和管理显著地降低资源使用和运维成本；多种计费模式极大地降低前期投入。',
          src: require('@/assets/images/save.png')
        }, {
          id: 5,
          title: '安全服务',
          content: '平台完善的隔离及网络监控服务，保障用户数据和服务安全无虞。',
          src: require('@/assets/images/safe-service.png')
        }],
      }
    }
	}
</script>

<style>

	@media (min-width:992px) {
    .platform-advantage {}

    .platform-advantage .title {
      margin: 120px auto 0;
      width: 120px;
      height: 34px;
      font-size: 30px;
      font-weight: 500;
      color: #3A3F4D;
      line-height: 34px;
    }

		.platform-advantage .box {
      width: 1400px;
      margin: 60px auto 120px;
      display: flex;
      flex-flow: row wrap;
      align-items: start;
      justify-content: space-between;
		}

		.platform-advantage .box .item {
			height: 389px;
			width: 380px;
		}

    .platform-advantage .box .item img {
      margin: 43px auto 0;
      width: 94px;
      height: 85px;
    }

    .platform-advantage .box .item .title {
      margin: 37px auto 0;
      width: 164px;
      height: 37px;
      font-size: 26px;
      font-weight: 500;
      color: #3B3A40;
      line-height: 37px;
    }

    .platform-advantage .box .item .description {
      margin: 13px auto 0;
      width: 310px;
      height: 104px;
      font-size: 16px;
      font-weight: 400;
      color: #64626A;
      line-height: 26px;
      opacity: 0.8;
    }

		.platform-advantage .box .item:hover {
			border-bottom: 4px solid #3890FF;
			box-shadow: 0px 2px 7px 0px rgba(158, 158, 237, 0.4);
			margin-bottom: -7px;
		}
	}

	.platform-advantage .box .item .up {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-bottom: 33px;
	}

	.platform-advantage .box .item .up h4 {
		margin: 24px 0 0 24px;
		color: #333333;
		font-size: 16px;
		font-weight: 500;
		line-height: 1.1;
		font-family: "microsoft yahei";
	}

	.platform-advantage .box .item p {
		text-align: left;
		color: #777;
		font-family: "microsoft yahei";
		font-size: 14px;
		line-height: 1.5;
	}

	@media (max-width:992px) {
		.platform-advantage .title {
			padding-top: 10px;
			margin-bottom: 15px;
		}

		.platform-advantage .title h2 {
			font-size: 18px;
			line-height: 60px;
		}

		.platform-advantage .title .vertical::before {
			content: '';
			display: block;
			position: absolute;
			top: 3px;
			left: -12px;
			width: 4px;
			height: 18px;
			background-color: #25A5FF;
		}

		.platform-advantage .box {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			margin: 0 10px;
			padding: 0;
		}

		.platform-advantage .box .item {
			margin: 0;
			padding: 0;
		}

		.platform-advantage .box .item .up {
			height: 60px;
			padding: 3px 10px;
			margin-bottom: 3px;
			background-color: rgba(52, 156, 227, .1);
			align-items: center;
			border-radius: 4px;
		}

		.platform-advantage .box .item .up img {
			height: 50px;
		}

		.platform-advantage .box .item .up h4 {
			margin: 0 0 0 5px;
		}
		.platform-advantage .box .item p {
			margin: 0 5px;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PlatformAdvantage.vue